import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { StarRatingModule } from '@spartacus/storefront';
import { CustomProductIntroComponent } from './product-intro.component';
import { ProductAddToWishListModule } from '../product-add-to-wish-list/product-add-to-wish-list.module';
import { TooltipIconComponent } from "../../../../components/tooltip-icon/tooltip-icon.component";

@NgModule({
  imports: [CommonModule, I18nModule, StarRatingModule, ProductAddToWishListModule, TooltipIconComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductIntroComponent: {
          component: CustomProductIntroComponent,
        },
      },
    }),
  ],
  declarations: [CustomProductIntroComponent],
  exports: [CustomProductIntroComponent],
})
export class CustomProductIntroModule {}
